export default __webpack_public_path__ + "maps-examples-default-callout-960-f55049e56bc076a12bd93240d1ad5b1a.webp";